/**
 * @generated SignedSource<<585a03ab00a465513ece4d23d14d5c17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassesGlobalFilterQuery$variables = {
  skip?: boolean | null | undefined;
};
export type ClassesGlobalFilterQuery$data = {
  readonly classes?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly section: string | null | undefined;
      readonly students: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type ClassesGlobalFilterQuery = {
  response: ClassesGlobalFilterQuery$data;
  variables: ClassesGlobalFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "classesFilterInput",
            "value": {
              "isActive": "ACTIVE",
              "siteIsActive": "ACTIVE"
            }
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 1000
          }
        ],
        "concreteType": "ClassNodeConnection",
        "kind": "LinkedField",
        "name": "classes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "section",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Student",
                "kind": "LinkedField",
                "name": "students",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "classes(classesFilterInput:{\"isActive\":\"ACTIVE\",\"siteIsActive\":\"ACTIVE\"},first:1000)"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesGlobalFilterQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassesGlobalFilterQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "57cb30eae618c896997e28cacd2070e7",
    "id": null,
    "metadata": {},
    "name": "ClassesGlobalFilterQuery",
    "operationKind": "query",
    "text": "query ClassesGlobalFilterQuery(\n  $skip: Boolean = false\n) {\n  classes(first: 1000, classesFilterInput: {isActive: ACTIVE, siteIsActive: ACTIVE}) @skip(if: $skip) {\n    nodes {\n      id\n      name\n      section\n      students {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c3fedb3cbcc3552012be2f507037355";

export default node;
